import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CONFIRMATION_DIALOG_ACTION_TYPE = createNamedActions('confirmationDialog', {
  OPEN_DIALOG: 'OPEN_DIALOG',
  CLOSE_DIALOG: 'CLOSE_DIALOG',
});

export const openConfirmationDialogAction = ({
  message,
  description,
  onAccept,
  onAcceptButtonName,
  onCancel,
  onCancelButtonName,
  customButtons,
  customDialogProps,
  type,
  body,
}) => {
  return {
    type: CONFIRMATION_DIALOG_ACTION_TYPE.OPEN_DIALOG,
    payload: {
      message,
      description,
      onAccept,
      onAcceptButtonName,
      onCancel,
      onCancelButtonName,
      type,
      customButtons,
      customDialogProps,
      body,
    },
  };
};

export const closeConfirmationDialogAction = () => {
  return {
    type: CONFIRMATION_DIALOG_ACTION_TYPE.CLOSE_DIALOG,
  };
};
